import React from 'react';
import Skeleton from '@material-ui/lab/Skeleton';
import Typography from '@material-ui/core/Typography';
import { useStyles } from './TakisSkeleton.styles';

const TakisArticleContentSkeleton = () => {
  const classes = useStyles();
  return (
    <div className={classes.recipeDetailContent}>
      <Typography className={classes.recipeDetailText} variant="h1">
        <Skeleton className={classes.recipeDetailParagraph} height="3.75rem"/>
      </Typography>
      <Typography className={classes.recipeDetailText} variation="body1">
        <Skeleton className={classes.recipeDetailParagraph} height="10rem" />
      </Typography>
    </div>
  );
}

export default TakisArticleContentSkeleton;
